module.exports = __webpack_public_path__ + "img/quickspin.ea30f928.svg";